var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPauseAnimationIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 0C7.83459 0 -0.000488281 7.83475 -0.000488281 17.5C-0.000488281 27.1653 7.83491 35 17.4995 35C27.1653 35 35.0003 27.1649 35.0003 17.5C35.0003 7.83425 27.1656 0 17.5003 0ZM17.5003 32.5004C9.21599 32.5004 2.49998 25.7845 2.49998 17.5C2.49998 9.2155 9.21583 2.49965 17.5003 2.49965C25.7855 2.49965 32.5007 9.21583 32.5007 17.5C32.5007 25.7842 25.7845 32.5004 17.5003 32.5004Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 23.3691C15.8337 24.155 15.197 24.7922 14.4109 24.7922H13.715C12.9291 24.7922 12.2918 24.1549 12.2918 23.3691L12.2915 11.6308C12.2915 10.8449 12.9288 10.208 13.7146 10.208H14.4105C15.1964 10.208 15.8333 10.8447 15.8333 11.6308L15.8337 23.3691Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7087 23.3691C22.7087 24.155 22.0721 24.7922 21.2865 24.7922H20.5903C19.8038 24.7922 19.1665 24.1549 19.1665 23.3691L19.1668 11.6308C19.1668 10.8449 19.8041 10.208 20.5906 10.208H21.2865C22.0721 10.208 22.7087 10.8447 22.7087 11.6308V23.3691Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPauseAnimationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pause_animation_icon.fb769487ea39720c559180027a132a8e.svg";